var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container my-5"},[_c('Login',{attrs:{"user-id":_vm.userId},on:{"loggedIn":_vm.loggedIn}}),(_vm.show)?_c('InstructorTable',{attrs:{"authorizationToken":_vm.authorizationToken,"clientLogin":_vm.clientLogin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }